import { CENTRA_LANGUAGE_CODE, type CentraLanguageCode } from "@/data/supported-languages"
import {
    isContentVisible,
    type VisibilityAwareItem
} from "@/src/utils/content/isContentVisible"

interface SanityInjectGeneralShortText extends VisibilityAwareItem {
    text?: Record<string, string>
}

function parseSanityInjectGeneralShortText(
    json: string | null | undefined
): SanityInjectGeneralShortText[] {
    if (!json) return []

    try {
        const parsed: unknown = JSON.parse(json)

        if (!Array.isArray(parsed)) return []

        return parsed as SanityInjectGeneralShortText[]
    } catch {
        return []
    }
}

function resolveLocalizedText(
    text: Record<string, string> | undefined,
    language: CentraLanguageCode
): string | undefined {
    if (!text) return undefined

    const firstTranslation = Object.entries(text).find(
        ([key, value]) => key !== "_type" && typeof value === "string" && value
    )?.[1]

    return text[language] || text[CENTRA_LANGUAGE_CODE.En] || firstTranslation
}

export function resolveSanityInjectGeneralShortText(
    json: string | null | undefined,
    language: CentraLanguageCode,
    locale: string
): string | undefined {
    const entries = parseSanityInjectGeneralShortText(json)

    const visibleEntry = entries.find(entry => isContentVisible(entry, locale))

    if (!visibleEntry) return undefined

    const resolved = resolveLocalizedText(visibleEntry.text, language)

    return resolved || undefined
}
